import _ from "lodash";
import { getIn } from "formik";
import PropTypes from "prop-types";
import React from "react";

import { createClassNameString } from "../../utils";
import { Dropdown } from "../../Dropdown";
import { FormFieldError } from "../FormFieldError/FormFieldError";
import { getAutomationDataAttr } from "../../../utils/automationUtils";
import { testLocator } from "../../../lib/helpers/test-locator";

import "../styles.scss";
import "./styles.scss";

export const FormMultiSelect = ({
  className,
  customError,
  dataPrivate,
  disabled,
  dropDownClassName,
  formikProps,
  name,
  options,
  placeholder,
  subTitle,
  testId,
  title,
  // normally form fields do not error until after submission
  // because they have not been touched
  // setting this to true triggers the error after editing
  // for the first time
  triggerErrorOnChange = false,
}) => {
  const errorMessage = getIn(formikProps.errors, name);
  const isTouched = getIn(formikProps.touched, name);
  const value = _.get(formikProps.values, name);

  const handleChange = async (event) => {
    const newValue = event.target.value?.map((item) => item.value) ?? [];

    await formikProps.setFieldValue(name, newValue);

    if (!isTouched && triggerErrorOnChange) {
      await formikProps.setFieldTouched(name, true);
    }
  };

  const selectedOptions = options.filter((item) => {
    return value.includes(item.value);
  });

  return (
    <div className={createClassNameString(["FormField-container", className])}>
      {(title || subTitle) && (
        <div className="FormField-header_container" data-public>
          {title && <h3 className="FormField-title">{title}</h3>}
          {subTitle && <h3 className="FormField-subTitle">{subTitle}</h3>}
        </div>
      )}

      <span data-private={dataPrivate} {...testLocator(testId)}>
        <Dropdown
          className={createClassNameString(["FormMultiSelect", dropDownClassName])}
          error={isTouched && errorMessage}
          isDisabled={disabled}
          isMulti={true}
          onChange={handleChange}
          options={options}
          placeholder={placeholder}
          value={selectedOptions}
          {...getAutomationDataAttr(testId, "id")}
        />
      </span>

      {!customError && errorMessage && isTouched && (
        <FormFieldError testId={testId && `${testId}-error`}>{errorMessage}</FormFieldError>
      )}
      {/* lets the dev pick what is displayed below the text area */}
      {customError && customError(value, errorMessage, isTouched)}
    </div>
  );
};

FormMultiSelect.propTypes = {
  className: PropTypes.string,
  customError: PropTypes.func,
  disabled: PropTypes.bool,
  formikProps: PropTypes.object,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  subTitle: PropTypes.string,
  title: PropTypes.string,
};
